import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HomePage } from './components/pages/HomePage/HomePage';
import { CreateNotePage } from './components/pages/CreateNotePage/CreateNotePage';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/create-note" element={<CreateNotePage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App; 